import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { STARFISH_UPGRADE } from './url-constants';

type StarfishUpgradeEndpointSpecification = ApiEndpointSpecification;
export const StarfishUpgradeEndpointSpecification: StarfishUpgradeEndpointSpecification = {
    url: STARFISH_UPGRADE,
    method: HttpMethod.PUT,
    requestParamsSchemaName: 'StarfishUpgradeRequestParams',
    requestBodySchemaName: 'StarfishUpgradeRequestBody',
    okResponseSchemaName: 'StarfishUpgradeOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeStarfishUpgrade = Helpers.makeApiRequestFn<
    Types.StarfishUpgradeRequestParams,
    Types.StarfishUpgradeRequestBody,
    Types.StarfishUpgradeOkResponse
>(StarfishUpgradeEndpointSpecification);
